<template>
	<UiElement class="d-flex flex-column h-100 pb-0" :settings="appearance.body.settings">
		<div class="d-flex flex-column align-items-center justify-content-center flex-grow-1">
			<UiText :settings="heading1" class="text-center" :content="translations?.paymentFailed || '{paymentFailed}'" />

			<UiText :settings="heading2" class="text-center" :content="translations?.paymentFailedTitle || '{paymentFailedTitle}'" />

			<div class="d-flex flex-column gap-5">
				<UiButton @touchstart="tryAgain" :settings="button1" :content="translations?.tryAgain || '{tryAgain}'" />

				<UiButton
					:settings="button2"
					@touchstart="cancelOrder"
					:content="translations?.cancel || '{cancel}'"
				/>
			</div>
		</div>
	</UiElement>
</template>

<script setup>
	import { computed, onMounted } from 'vue';
	import { storeToRefs } from 'pinia';
	import { useRouter } from 'vue-router';
	import { useIdleStore } from '@/stores/useIdleStore';
	import { useThemeStore } from '@/stores/useThemeStore';
	import { useOrderStore } from '@/stores/useOrderStore';
	import { useTranslationsStore } from '@/stores/useTranslationsStore';
	import { useInheritedSettings } from '@/composables/useInheritedSettings';
	import { useKioskRoute } from '@/composables/useKioskRoute';
	import UiElement from '@/components/UI/UiElement.vue';
	import UiText from '@/components/UI/UiText.vue';
	import UiButton from '@/components/UI/UiButton.vue';

	const router = useRouter();

	const { makePath } = useKioskRoute();

	const themeStore = useThemeStore();
	const orderStore = useOrderStore();
	const translationsStore = useTranslationsStore();
	const { cancelUsage } = useIdleStore();

	const { clearCart } = orderStore;

	const { translations } = storeToRefs(translationsStore);
	const { theme } = storeToRefs(themeStore);

	const page = computed(() => theme.value.pages.paymentFailed);
	const appearance = computed(() => page.value.appearance);
	const elements = computed(() => page.value.elements);

	const heading1 = useInheritedSettings(computed(() => elements.value?.heading1));
	const heading2 = useInheritedSettings(computed(() => elements.value?.heading2));
	const button1 = useInheritedSettings(computed(() => elements.value?.button1));
	const button2 = useInheritedSettings(computed(() => elements.value?.button2));

	function cancelOrder() {
		clearCart();
		cancelUsage();

		router.push(makePath('/'));
	}

	let timeout;

	function tryAgain() {
		clearTimeout(timeout);

		router.push(makePath('/summary'));
	}

	onMounted(() => {
		if (window.self === window.top) {
			timeout = setTimeout(() => {
				cancelUsage();
			}, 10000);
		}
	});
</script>